import { render } from "./InvestBuy.vue?vue&type=template&id=c16c83ec"
import script from "./InvestBuy.vue?vue&type=script&lang=js"
export * from "./InvestBuy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__